import React from 'react';
import { ADDRESS_STATUS, addressStatus } from './addressStatus';

export const AddressStatusChip = ({ guest }) => {
  const key = addressStatus(guest);
  if (key === 'ok') return null;
  const [label, cls] = ADDRESS_STATUS[key];
  return (
    <span data-testid={`guest-address-status-${guest.id}`} title="Mailing address status"
      className={`text-[9px] uppercase tracking-wider border px-1.5 py-0.5 rounded-full whitespace-nowrap ${cls}`}>
      Address: {label}
    </span>
  );
};

export default AddressStatusChip;
